import styled from "styled-components";

export const ActivityItemStyled = styled.div`
  font-family: Nunito Sans;
  font-style: normal;
  background-color: white;
  height: 87px;
  margin-bottom: 12px;
  border: 1px solid #C4C4C4;
  padding: 21px 25px;
  display: flex;
  align-items: center;
`;

export const Label = styled.div`

`;

export const Date = styled.div`

`;

export const LeftContent = styled.div`
  width: 45px;
  flex: 0 0 45px;
  svg {
    width: 20px;
    path {
      fill: #97AA5C
    }
  }
`;

export const CenterContent = styled.div`
  flex: 1;
  letter-spacing: 0.01em;
  font-size: 14px;
`;

export const RightContent = styled.div`
  width: 100px;
  flex: 0 0 100px;
`;

export const MetricAmount = styled.div<{ ItWasRedeemed: boolean }>`
  font-weight: bold;
  font-size: 18px;
  text-align: right;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: ${(props) => (props.ItWasRedeemed ? '#DC4547' : '#000000')};
`;

export const ItemTypeName = styled.div`
  font-size: 14px;
  text-align: right;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`;

export const Location = styled.div`
`;